export default __webpack_public_path__ + "static/img-media-business-today-8303fa4efe28185e3e48f9c72f234506.jpg";